import dynamicFormState from '../ctas/initialStates/dynamicFormState';
import emailCollectionState from '../ctas/initialStates/emailCollectionState';

const totalAgentTypes = [
  {
    name: 'Email Collection Agent',
    value: 'emailCollection',
    actionType: emailCollectionState.actionData.actionType,
    description:
      'Grow your email list through richer engagements and contextual native sign-up prompts',
    isLocked: false,
    agentType: 'visitor',
    agentCategory: 'invisible',
    icon: 'emailCollection',
  },
  {
    name: 'Dynamic Form Agent',
    value: 'surveyAndForm',
    actionType: dynamicFormState.actionData.actionType,
    description: 'Grow customer info list through richer engagements and contextual native forms',
    isLocked: false,
    agentType: 'visitor',
    agentCategory: 'invisible',
    icon: 'dynamicForm',
  },
  {
    name: 'Knowledge Agent',
    value: 'smartReply',
    description:
      'Engage with your audience through contextual native replies and personalised responses',
    isLocked: true,
    agentType: 'smartReply',
    agentCategory: 'engagement',
    icon: 'smartReply',
  },
  {
    name: 'Smart Offerwall Agent',
    value: 'recirculation',
    actionType: 'allCtas',
    description:
      'Keep your audience engaged and on your site longer with personalised journeys that encourage them to explore more of your content.',
    isLocked: false,
    agentType: 'visitor',
    agentCategory: 'monetize',
    bucketType: 'recirculation',
    icon: 'recirculation',
    aiEngineType: 'polling',
  },
  {
    name: 'Smart Reading Agent',
    value: 'xRay',
    // actionType: emailCollectionState.actionData.actionType,
    actionType: 'allCtas',
    description:
      'Enhances reader experience by providing AI-powered content summaries, insights, and personalised recommendations.',
    isLocked: false,
    agentType: 'visitor',
    agentCategory: 'engage',
    bucketType: 'recirculation',
    engineType: 'pageMetaDataMatch',
    aiEngineType: 'sra',
    icon: 'sra',
    learnMoreLink: 'https://youtu.be/r6mml1Q2Vhc?si=QQQfx3C_ohdRC1qW',
  },
  {
    name: 'Polling Agent',
    value: 'engagementOnly',
    actionType: 'allCtas',
    description:
      'Adds contextual interactive polls and quizzes to maximise user engagement, loyalty, and first-party data collection.',
    isLocked: true,
    agentType: 'visitor',
    agentCategory: 'invisible',
    icon: 'polling',
    learnMoreLink: 'https://youtu.be/F6cJ_Ywh0rk?si=mMQYGkTzc0nxbBo6',
  },
  {
    name: 'Polling Agent',
    value: 'pollingAgent',
    actionType: 'allCtas',
    description:
      'Adds contextual interactive polls and quizzes to maximise user engagement, loyalty, and first-party data collection.',
    isLocked: false,
    agentType: 'visitor',
    agentCategory: 'engage',
    aiEngineType: 'polling',
    icon: 'polling',
    learnMoreLink: 'https://youtu.be/F6cJ_Ywh0rk?si=mMQYGkTzc0nxbBo6',
  },
  {
    name: 'Smart Offerwall Agent',
    value: 'affiliateLink',
    actionType: 'link',
    isLocked: true,
    description:
      'Dynamically presents personalised offers, content recommendations, and paywalls to drive user monetisation and subscription conversions.',
    agentType: 'visitor',
    agentCategory: 'invisible',
    icon: 'affiliateLink',
  },
  {
    name: 'Knowledge Agent',
    value: 'rag',
    actionType: 'allCtas',
    description:
      "Offers AI-powered Q&A interfaces, enabling users to explore reports, articles, and databases interactively within the publisher's content.",
    isLocked: false,
    agentType: 'visitor',
    staticActionType: 'link',
    agentCategory: 'engage',
    bucketType: 'knowledgeAgent',
    aiEngineType: 'ka',
    icon: 'knowledgeAgent',
    learnMoreLink: 'https://www.youtube.com/watch?v=z3x_bBFDeZM',
  },
  {
    name: 'Data Explorer Agent',
    value: 'DEA',
    actionType: 'allCtas',
    description:
      'Helps editorial and operational teams explore, analyse, and visualise data efficiently, highlighting key insights.',
    isLocked: false,
    agentType: 'visitor',
    agentCategory: 'engage',
    icon: 'dataExplorerAgent',
    learnMoreLink: 'https://youtu.be/S9vNn8XzgN0?si=RWbxUL57mEsanICv',
    aiEngineType: 'dea',
    bucketType: 'knowledgeAgent',
  },
  {
    name: 'Drafter Agent',
    value: 'ResearchPartner',
    description:
      'Generates draft articles and content quickly, reducing editorial effort and speeding up publishing workflows.',
    isLocked: false,
    agentType: 'aiAgent',
    agentCategory: 'automate',
    icon: 'researchPartner',
    learnMoreLink: 'https://youtu.be/3WDKL4HZdbQ?si=tdE3ReWrB0Yi7Fa-',
  },
  // {
  //   name: 'Data Explorer Agent',
  //   value: 'DEA',
  //   description:
  //     'Helps editorial and operational teams explore, analyze, and visualize data efficiently, highlighting key insights.',
  //   isLocked: false,
  //   agentType: 'aiAgent',
  //   agentCategory: 'automate',
  //   icon: 'dataExplorerAgent',
  //   learnMoreLink: 'https://youtu.be/S9vNn8XzgN0?si=RWbxUL57mEsanICv',
  //   aiEngineType: 'dea',
  // },
  {
    name: 'SEO Agent',
    value: 'ProSEOOptimizer',
    description:
      'Identifies high-potential SEO opportunities and analyses keywords/topics relevant to your audience to optimise content visibility.',
    isLocked: false,
    agentType: 'aiAgent',
    agentCategory: 'automate',
    icon: 'seoOptimizer',
    learnMoreLink: 'https://youtu.be/_KwLKe5w4u4?si=sT_sPte6U4dB-Ib-',
  },
  {
    name: 'Rule Checker Agent',
    value: 'RuleChecker',
    description:
      'Check your content for any rule violations and fix them to ensure your content is compliant with the latest regulations',
    isLocked: true,
    agentType: 'aiAgent',
    agentCategory: 'automate',
    icon: 'RuleChecker',
    learnMoreLink: 'https://youtu.be/1il9H_YOgGE?si=_E4g2CgqOMenS8iE',
  },
  {
    name: 'Advertiser Ad-On Agent',
    value: 'advertiserAdOn',
    description:
      'Optimises advertiser spend by increasing targeting accuracy and ad performance within publisher environments.',
    isLocked: true,
    agentType: 'aiAgent',
    agentCategory: 'monetize',
    icon: 'advertiserAdOn',
  },
  {
    name: 'Qualification Agent',
    value: 'qualification',
    description:
      'Enables to visualise leads in their funnel and create personalised messaging for improved monetisation and advertiser relationships.',
    isLocked: false,
    agentType: 'qualification',
    agentCategory: 'monetize',
    icon: 'qualification',
  },
  {
    name: 'Personalised Email Activation',
    value: 'ptEmailChannel',
    description:
      'Activation-only — email and personalised links, no web agent. Recommend and reach contacts across rich email blasts or personalised landing pages.',
    isLocked: false,
    agentType: 'ptEmailChannel',
    agentCategory: 'engage',
    icon: 'personalizationAgent',
  },
];

export default totalAgentTypes;
